<template>
    <div class="box" >
        <div class="image_box">
            <img class="image" :src="img_api + project.imageList[0].url" alt="">
        </div>
        <div class="box_bottom">
            <div class="box_title">{{project.name}}</div>
        </div>
    </div>
</template>

<script>

export default {
    name: '',
    props: [
        'project'
    ],
    data() {
        return {
            img_api: 'https://www.gdyuanwo.com/gdyuanwo/',
        }
    }
};
</script>

<style scoped>
.box {
    width: 318px;
    background-color: #F7F8FA;
    margin-bottom: 16px;
    margin-left: 16px;
    box-shadow: 4px 6px 16px 4px rgba(0, 0, 0, 0.1);

}
.box:hover{
    cursor: pointer;
}
.image_box {
    max-width: 298px;
    height: 227px;
    padding: 10px;
}

.image {
    width: 100%;
    height: 100%;
}

.box_bottom {
    border-top: 1px solid #C8D4E1;
    /* height: 69px; */
    display: flex;
    justify-content: center;
}

.box_title {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    padding: 13px;
}
</style>
